<template>
  <div id="booking-service">
    <div v-show="noticeVisible" class="content notice">
      <div>
        <i class="iconfont">&#xe6e5;</i>
        <span
          >1.服务申请次数将每月都会清零哦，请记得每个月发起申请！
          2.快速预约技术专家</span
        >
        <a
          :href="`aliim:sendmsg?uid=cntaobao&siteid=cntaobao&touid=cntaobao${userInfo.ww}`"
          @click="sendEmail"
        >
          <img src="../../assets/image/common/ww.png" alt="" />
          <span class="ml6 theme-color">和我联系</span>
        </a>
        <span>(周一至周五 08:30-18:00)</span>
      </div>
      <i class="iconfont" @click="noticeVisible = false">&#xe6c7;</i>
    </div>
    <div class="flex-center content" :style="{ height: carouselHeight() }">
      <div style="width: 1182px; margin-top: 60px">
        <!--预约服务大图标-->
        <div class="flex-between">
          <!--直通车诊断-->
          <div v-show="versionVisible" class="flex-start diagnose diagnose-ztc">
            <div
              class="img-box flex-center align-center"
              style="
                background-color: #806bea;
                box-shadow: 0px 2px 10px 0px rgba(128, 107, 234, 0.44);
              "
            >
              <img src="../../assets/image/service/diagnose-ztc.png" alt="" />
            </div>
            <div class="img-note flex-center align-center">
              <div>
                <div class="f20 font-bold">直通车诊断</div>
                <div class="diagnose-cycle f12">每月一次</div>
                <div>
                  <el-button
                    class="diagnose-button"
                    style="background-color: #806bea"
                    @click="diagnoseZtc"
                    >兑换申请
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <!--店铺诊断-->
          <div
            v-show="versionVisible"
            class="flex-start diagnose diagnose-shop"
          >
            <div
              class="img-box flex-center align-center"
              style="
                background-color: #83a4ff;
                box-shadow: 0px 2px 10px 0px rgba(131, 164, 255, 0.49);
              "
            >
              <img src="../../assets/image/service/diagnose-shop.png" alt="" />
            </div>
            <div class="img-note flex-center align-center">
              <div>
                <div class="f20 font-bold">店铺诊断</div>
                <div class="diagnose-cycle f12">每月一次</div>
                <div>
                  <el-button
                    class="diagnose-button"
                    style="background-color: #83a4ff"
                    @click="diagnoseShop"
                    >兑换申请
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <!--创意制作-->
          <div
            v-show="creativeVisible"
            class="flex-start diagnose diagnose-creative"
          >
            <div
              class="img-box flex-center align-center"
              style="
                background-color: #ff5200;
                box-shadow: 0px 2px 10px 0px rgba(255, 82, 0, 0.44);
              "
            >
              <img
                src="../../assets/image/service/diagnose-creative.png"
                alt=""
              />
            </div>
            <div class="img-note flex-center align-center">
              <div>
                <div class="f20 font-bold">创意制作</div>
                <div class="diagnose-cycle f12">每月一次</div>
                <div>
                  <el-button
                    class="diagnose-button"
                    style="background-color: #ff5200"
                    @click="diagnoseCreative"
                    >兑换申请
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--预约服务兑换记录表格-->
        <div
          v-show="feedBackList.length > 0"
          class="diagnose-record flex-start"
        >
          <el-table :data="feedBackList" stripe style="width: 100%">
            <el-table-column>
              <template v-slot:header>
                <div class="table-tl pl20">申请时间</div>
              </template>
              <template v-slot:default="scope">
                <div class="table-tl pl20 f13">{{ scope.row.create_time }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="处理时间"
              prop="handle_time"
            ></el-table-column>
            <el-table-column label="状态">
              <template v-slot:default="scope">
                <div v-show="scope.row.deal_flag === true" class="deal-box-ok">
                  <div class="f12">{{ scope.row.status_desc }}</div>
                </div>
                <div
                  v-show="scope.row.deal_flag === false"
                  class="deal-box-ing"
                >
                  <div class="f12">{{ scope.row.status_desc }}</div>
                </div>
              </template>
            </el-table-column>
            <!--申请类型由于设置了宽度，表格无法很好对齐，空的列，占位对齐用-->
            <el-table-column :width="145"></el-table-column>
            <el-table-column
              :width="150"
              label="申请类型"
              prop="service_type_desc"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!--确认提醒的对话框-->
    <el-dialog
      title="申请直通车诊断"
      :visible.sync="ztcVisible"
      custom-class="small-dialog"
      :model="dialogZtc"
    >
      <el-form :label-position="labelPosition" label-width="80px">
        <el-form-item label="选择计划">
          <el-select
            v-model="dialogZtc.campaignName"
            placeholder="请选择"
            style="width: 274px"
          >
            <el-option
              v-for="campaign in this.campaignTitleList"
              :key="campaign"
              :label="campaign"
              :value="campaign"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提升方向">
          <el-radio-group v-model="dialogZtc.promoteDirection">
            <div class="flex-start align-center">
              <el-radio label="提升流量">提升流量</el-radio>
              <el-radio label="提升转化">提升转化</el-radio>
              <el-radio label="其他">其他</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dialogZtc.note" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDiagnoseZtc">保存</el-button>
        <el-button @click="ztcVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="精灵提醒"
      :visible.sync="shopVisible"
      custom-class="small-dialog"
    >
      <el-form :label-position="labelPosition" label-width="80px">
        <div>
          您正在申请“店铺诊断”的需求，我们会在5个工作日内对您的店铺进行详细诊断哦！
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDiagnoseShop">确定</el-button>
        <el-button @click="shopVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="申请兑换创意制作"
      :visible.sync="ctvApplyVisible"
      custom-class="small-dialog"
    >
      <el-form :label-position="labelPosition" label-width="80px">
        <div>需要5000积分兑换一张创意图制作，您确定要兑换吗？</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitApplyDiagnoseZtc"
          >确定</el-button
        >
        <el-button @click="ctvApplyVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="申请兑换创意制作"
      :visible.sync="ctvVisible"
      custom-class="small-dialog"
    >
      <el-form :label-position="labelPosition" label-width="80px">
        <el-form-item label="选择图片">
          <el-upload
            ref="uploadCtv"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="uploadOnChange"
            :on-remove="uploadOnRemove"
            :http-request="httpRequest"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload">保存</el-button>
        <el-button @click="ctvVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BookingService",
  data() {
    return {
      noticeVisible: true,
      versionVisible: false,
      creativeVisible: false, // 创意诊断默认可见，此处是为了兼容前端页面一起显示
      labelPosition: "right",
      version: "",
      point: 0,
      campaignTitleList: [],
      feedBackList: [],
      ztcVisible: false,
      shopVisible: false,
      ctvApplyVisible: false,
      ctvVisible: false,
      dialogZtc: {
        campaignName: "",
        promoteDirection: "",
        note: "",
      },
      imgUrl: "",
    };
  },
  beforeMount() {
    this.getFreeBookingService();
  },
  methods: {
    sendEmail() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "add_appointment_shop_diagnosis",
        },
        () => {}
      );
    },
    getFreeBookingService() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "get_free_booking_service",
        },
        (res) => {
          this.version = res.data[0].version;
          this.campaignTitleList = res.data[0].campaign_title_list;
          this.feedBackList = res.data[0].feedback_list;
          if (this.version !== 4 && this.version !== 5) {
            this.versionVisible = true;
          }
          this.creativeVisible = true;
        }
      );
    },
    diagnoseZtc() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "check_service_apply",
          service_type: 1,
        },
        () => {
          this.ztcVisible = true;
          this.dialogZtc.campaignName = "";
          this.dialogZtc.promoteDirection = "";
          this.dialogZtc.note = "";
        }
      );
    },
    diagnoseShop() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "check_service_apply",
          service_type: 2,
        },
        () => {
          this.shopVisible = true;
        }
      );
    },
    diagnoseCreative() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "check_service_apply",
          service_type: 4,
        },
        (res) => {
          this.point = res.data[0].point;
          this.ctvApplyVisible = true;
        }
      );
    },
    submitDiagnoseZtc() {
      if (this.dialogZtc.campaignName === "") {
        this.$notification("warn", "请选择计划！");
        return;
      }
      if (this.dialogZtc.promoteDirection === "") {
        this.$notification("warn", "请选择提升方向！");
        return;
      }
      let suggest =
        "直通车诊断服务申请，诊断计划：" +
        this.dialogZtc.campaignName +
        "，提升方向：" +
        this.dialogZtc.promoteDirection;
      if (this.dialogZtc.note) {
        suggest += "，备注：" + this.dialogZtc.note;
      }

      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "add_suggest",
          service_type: 1,
          suggest: suggest,
        },
        () => {
          this.ztcVisible = false;
          this.getFreeBookingService();
        },
        "申请成功！"
      );
    },
    submitDiagnoseShop() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "add_suggest",
          service_type: 2,
          suggest: "店铺诊断服务申请",
        },
        () => {
          this.shopVisible = false;
          this.getFreeBookingService();
        },
        "申请成功！"
      );
    },
    submitApplyDiagnoseZtc() {
      this.ctvApplyVisible = false;
      if (this.point < 5000) {
        this.$notification("warn", "亲！您的兑换积分不够！");
      } else {
        this.ctvVisible = true;
      }
    },
    // 只需要一张图片，选择后隐藏图片选择框，删除图片后恢复图片选择框
    uploadOnChange(file) {
      this.$(".el-upload--picture-card").css("display", "none");
      this.getFile(file);
    },
    uploadOnRemove() {
      this.$(".el-upload--picture-card").css("display", "block");
      this.imgUrl = "";
    },
    httpRequest() {
      this.$axios(
        "/api/kcjl/shop/",
        {
          func: "add_suggest",
          service_type: 4,
          suggest: "创意制作服务申请",
          src: this.imgUrl,
        },
        () => {
          this.getFreeBookingService();
          this.ctvVisible = false;
        },
        "申请成功！"
      );
    },
    beforeUpload(file) {
      let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$notification(
          "warn",
          "上传图片格式不支持，请选择JPG/PNG 图片格式！"
        );
        return false;
      }
      if (!isLtSize) {
        this.$notification("warn", "上传图片大小不能超过 10MB!");
        return false;
      }
      return true;
    },
    submitUpload() {
      if (this.imgUrl === "") {
        this.$notification("warn", "请选择上传图片！");
      }
      this.$refs.uploadCtv.submit();
    },
    getFile(file) {
      this.$utils.getBase64(file.raw).then((res) => {
        this.imgUrl = res;
      });
    },
    carouselHeight() {
      let cHeight = document.documentElement.clientHeight;
      let setHeiht = 0;
      let noticeHeight = this.noticeVisible ? 54 : 0;
      let tableRow = this.feedBackList.length;
      // 所需高度是超过或不超过屏幕高度，分两种情况处理
      if (72 + noticeHeight + 252 + 48 + 48 * tableRow + 20 + 56 < cHeight) {
        setHeiht = cHeight - 72 - noticeHeight - 56;
      } else {
        setHeiht = 252 + 48 + 48 * tableRow + 20;
      }
      return `${setHeiht}px`;
    },
  },
  computed: {
    ...mapState(["activeTheme", "userInfo"]),
  },
};
</script>

<style scoped lang="scss">
#booking-service {
  padding: 0 20px;
  margin-bottom: 56px;

  .diagnose {
    width: 386px;
    height: 180px;
    border-radius: 20px;

    .img-box {
      margin: 24px 0 0 31px;
      width: 158px;
      height: 132px;
      border-radius: 20px;
      color: #fff;
    }

    .img-note {
      width: 223px;
    }

    .diagnose-cycle {
      color: $base-gray;
    }

    .diagnose-button {
      width: 82px;
      height: 32px;
      margin-top: 12px;
      border-radius: 4px;
      font-size: 13px !important;
      font-weight: 500;
      color: #ffffff;
      line-height: 18px;
      text-align: center;
      border: none;
      padding: 0px !important;

      &:hover {
        color: #fff !important;
        background: #f04d00 !important;
      }
    }
  }

  .diagnose-ztc {
    background: rgba(128, 107, 234, 0.1);
  }

  .diagnose-shop {
    background: rgba(131, 164, 255, 0.1);
  }

  .diagnose-creative {
    background: rgba(255, 82, 0, 0.1);
  }

  .diagnose-record {
    padding-top: 12px;
  }

  .deal-box-ok {
    width: 54px;
    height: 22px;
    background: #e5f8f2;
    border-radius: 2px;
    text-align: center;
    color: #00ba7d;
  }

  .deal-box-ing {
    width: 54px;
    height: 22px;
    background: #ffede5;
    border-radius: 2px;
    text-align: center;
    color: #ff5200;
  }

  /deep/ textarea.el-textarea__inner {
    height: 136px;
  }
}
</style>